import React from 'react';
import { cn } from '../../lib/utils';

interface FormErrorProps {
  error?: string;
  className?: string;
}

/**
 * 表单错误显示组件
 */
export const FormError: React.FC<FormErrorProps> = ({ error, className }) => {
  if (!error) return null;

  return (
    <p className={cn('text-sm text-destructive mt-1', className)}>
      {error}
    </p>
  );
};

/**
 * 表单错误列表组件（用于显示多个错误）
 */
interface FormErrorListProps {
  errors: string[];
  className?: string;
}

export const FormErrorList: React.FC<FormErrorListProps> = ({ errors, className }) => {
  if (errors.length === 0) return null;

  return (
    <div className={cn('space-y-1', className)}>
      {errors.map((error, index) => (
        <FormError key={index} error={error} />
      ))}
    </div>
  );
};
